<ion-app>
  <div class="desktop-warning">
    <img src="assets/icons/logo.svg" alt="Logo" class="desktop-warning-logo" />
    <p class="desktop-warning-text">This Treasure Hunt is currently available on mobile devices only</p>
  </div>

  <ion-router-outlet></ion-router-outlet>
  <app-tabs></app-tabs>
  <app-starly-toast></app-starly-toast>
</ion-app>